import React from "react";
import PropTypes from "prop-types";
import { AutoComplete, Icon, Input, Divider, Checkbox } from "antd";
import QuickSearchService from "services/quick-search-service";
import debounce from "lodash/debounce";
import noop from "lodash/noop";
import { CASE_ACTIVE_STATUS } from "constants/enums";
import "styles/quick-search.css";
// import { CASE_VIEW_ACTION } from "constants";

const Option = AutoComplete.Option;

class QuickSearch extends React.Component {
    state = {
        list: [],
        count: 0,
        utilization: [],
        buyerId: null,
        loading: false,
        visible: false
    };
    companyView = null;
    notificationPipe = [];
    onSearch = (() => {
        const debounceSearchHandler = debounce(
            str =>
                str && str.length > 0
                    ? QuickSearchService.caseLookup("all", str).then(
                        ({ data }) => {
                            this.setState({
                                list: data.results,
                                count: data.count,
                                loading: false
                            });
                        })
                    : noop,
            1200
        );
        return str => {
            this.setState({
                loading: str && str.length > 0 ? true : false
            });
            if (str.length === 0) {
                this.setState({
                    list: []
                });
            }
            debounceSearchHandler(str);
        };
    })();

    onSelect = (name, option) => {
        const record = option.props.record;
        this.props.openDrawer(record);
    };

    onOptionHover = () => null;
    getOption = (option) => {
        let current_stage = option.current_case_task && option.current_case_task.filter(_ => _.this_stage && _.this_stage.stage_name !== "Sales Manager");
        current_stage = current_stage.map(_ => _.this_stage && _.this_stage.stage_name).join(" | ");
        let case_status = CASE_ACTIVE_STATUS.findKey(_ => option.case_status === _);
        return `${option.company.name}(${option.id})(${option.company && option.company.gstin})(${current_stage})(${case_status})`;
    }
    searchFilters = [
        {
            label: "GSTIN",
            value: "gstin",
        },
        {
            label: "Case Id",
            value: "caseId",
        },
        {
            label: "Name",
            value: "name",
        }
    ]

    onSearchFilterChange = () => {};
    render() {
        const { loading } = this.state;
        return (
            <React.Fragment>
                <AutoComplete
                    // style={{
                    //     minWidth: "450px"
                    // }}
                    className="search-autocomplete"
                    onSearch={this.onSearch}
                    onSelect={this.onSelect}
                    placeholder={"Search Cases"}
                    optionLabelProp={"value"}
                    filterOption={(input, option) =>
                        input &&
                        input.length > 0 &&
                        option.props.value
                            .toLocaleLowerCase()
                            .includes(input.toLocaleLowerCase())
                    }
                    dataSource={this.state.list.map(_ => (
                        <Option
                            key={_.id}
                            name={_.company.name}
                            caseId={_.id}
                            value={this.getOption(_)}
                            companyId={_.company.id}
                            record={_}
                        >
                            {this.getOption(_)}
                        </Option>
                    ))}
                    dropdownMatchSelectWidth={false}
                    dropdownRender={menu => {
                        return (
                            <div>
                                <div className={"d-flex justify-content-space-between"} style={{ padding: "8px", backgroundColor: "#fafafa"}}>
                                    <div className={"quick-search-checkbox"}>
                                        <span>Results matching only:</span>{"   "}
                                        <Checkbox.Group
                                            options={this.searchFilters}
                                            onChange={this.onSearchFilterChange}
                                            onMouseDown={e => e.preventDefault()}
                                        />
                                    </div>
                                    <div>
                                        <span style={{ fontSize: "12px"}}>{this.state.count} results found</span>
                                    </div>
                                </div>
                                <Divider style={{ margin: "0 0 4px 0" }} />
                                {menu}
                            </div>
                        );
                    }}
                >   
                    <Input
                        suffix={
                            <Icon
                                type={loading ? "sync" : "search"}
                                spin={loading}
                            />
                        }
                    />
                </AutoComplete>
            </React.Fragment>
        );
    }
}

QuickSearch.propTypes = {
    history: PropTypes.object,
    location: PropTypes.object,
    openDrawer: PropTypes.func
};

export default QuickSearch;
